var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8202 16.72C12.5102 16.72 12.2102 16.52 12.1102 16.21L10.0802 10.11L7.34024 16.28C7.17024 16.66 6.73024 16.83 6.35024 16.66C5.97024 16.49 5.80024 16.05 5.97024 15.67L9.50024 7.73999C9.63024 7.45999 9.90024 7.26999 10.2202 7.29999C10.5302 7.30999 10.8002 7.52 10.9002 7.81L13.5402 15.74C13.6702 16.13 13.4602 16.56 13.0702 16.69C12.9802 16.7 12.9002 16.72 12.8202 16.72Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9398 12.57H7.52979V14.07H11.9398V12.57Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3501 16.72C15.9401 16.72 15.6001 16.38 15.6001 15.97V10.68C15.6001 10.27 15.9401 9.92999 16.3501 9.92999C16.7601 9.92999 17.1001 10.27 17.1001 10.68V15.97C17.1001 16.38 16.7601 16.72 16.3501 16.72Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3501 9.02999C16.0801 9.02999 15.8301 8.92998 15.6401 8.73998C15.5501 8.64998 15.4701 8.54 15.4201 8.42C15.3701 8.29 15.3501 8.16999 15.3501 8.02999C15.3501 7.89999 15.3701 7.76998 15.4201 7.64998C15.4801 7.52998 15.5501 7.41997 15.6401 7.32997C15.7301 7.22997 15.8401 7.15997 15.9601 7.10997C16.3301 6.95997 16.7801 7.04997 17.0501 7.32997C17.1501 7.41997 17.2201 7.52998 17.2701 7.64998C17.3201 7.76998 17.3501 7.89999 17.3501 8.02999C17.3501 8.16999 17.3201 8.3 17.2701 8.42C17.2201 8.54 17.1501 8.64998 17.0501 8.73998C16.9601 8.82998 16.8501 8.90998 16.7301 8.95998C16.6101 9.00998 16.4801 9.02999 16.3501 9.02999Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.0c13f08d03d71518206bc4f2565c45f5.svg";
export { ForwardRef as ReactComponent };